const KILOBYTE = 1024;
const MEGABYTE = 1024 * 1024;

/**
 * Human readable document size, matching the CSP portal document table.
 */
export default function formatBytes(sizeBytes?: number): string {
  if (sizeBytes == null || sizeBytes === 0) {
    return '—';
  }

  if (sizeBytes < KILOBYTE) {
    return `${sizeBytes} B`;
  }

  if (sizeBytes < MEGABYTE) {
    return `${(sizeBytes / KILOBYTE).toFixed(1)} KB`;
  }

  return `${(sizeBytes / MEGABYTE).toFixed(1)} MB`;
}
